export default class ScreenResolution {
    static isDesktop() {
        return window.matchMedia('(min-width: 621px)').matches;
    }

    static isSwiperDesktop() {
        return window.matchMedia('(min-width: 768px)').matches;
    }

    static isMobile() {
        return window.matchMedia('(max-width: 620px)').matches;
    }

    static isTablet() {
        return window.matchMedia('(max-width: 767px)').matches;
    }

    static isTabletL() {
        return window.matchMedia('(max-width: 868px)').matches;
    }

    static isTabletXL() {
        return window.matchMedia('(max-width: 1024px)').matches;
    }

    static isPortrait() {
        return window.matchMedia('(orientation: portrait)').matches;
    }
}
